import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { ANIMATIONS } from 'utils/Animations';
import WebNote from './WebNote';
import WebNoteAdd from './WebNoteAdd';

const QuestionNotes = ({ auth, notes, question, qNumber, params, createNote, deleteNote, updateNote }) => {
  const webNotesLength = notes.length - 1;
  const webNotes = notes.map((n, idx) =>
    <CSSTransition key={n.id} timeout={{ enter: ANIMATIONS.in, exit: ANIMATIONS.out }} classNames='a-fade'>
      <WebNote note={n} params={params} onDelete={deleteNote} onUpdate={updateNote} isLast={idx === webNotesLength} auth={auth} />
    </CSSTransition>
  );
  return (
    <div className='column u-margin-top--base u-margin-bottom--base'>
      <div className='o-question row align-middle u-margin-bottom--tiny'>
        <div className='column shrink u-padding-right--zero'>
          <span className='o-question__number'>{qNumber}</span>
        </div>
        <div className='u-margin-left--small column u-padding-left--zero'>
          <b>{question.boldBody}</b>
        </div>
      </div>
      <div className='row'>
        <div className='column shrink u-padding-right--zero'>
          <span className='o-question__number--blank'></span>
        </div>
        <div className='u-margin-left--small column u-padding-left--zero'>
          <TransitionGroup>
            {webNotes}
          </TransitionGroup>
          { params.playerQuestionnaireId && <WebNoteAdd question={question} params={params} onAdd={createNote} /> }
        </div>
      </div>
    </div>
  );
}

QuestionNotes.propTypes = {
  auth: PropTypes.object.isRequired,
  notes: PropTypes.arrayOf(PropTypes.object).isRequired,
  question: PropTypes.object.isRequired,
  qNumber: PropTypes.number.isRequired,
  params: PropTypes.object.isRequired,
  createNote: PropTypes.func.isRequired,
  deleteNote: PropTypes.func.isRequired,
  updateNote: PropTypes.func.isRequired,
}

export default QuestionNotes;
